import { render, staticRenderFns } from "./Reminder-item.vue?vue&type=template&id=17f1756d&scoped=true&lang=html"
import script from "./Reminder-item.vue?vue&type=script&lang=js"
export * from "./Reminder-item.vue?vue&type=script&lang=js"
import style0 from "./Reminder-item.vue?vue&type=style&index=0&id=17f1756d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f1756d",
  null
  
)

export default component.exports